import { Grid } from '@xo-union/ui-card-grid';
import React from 'react';

import { ThemesQuery } from '../../generated/graphql';
import { SortOrder } from '../helpers/useThemes';
import ThemeCard from './Card';
import styles from './index.scss';

interface Props {
  themes?: ThemesQuery['familyThemes'];
  sortOrder?: SortOrder;
}

export const ThemeGrid: React.FC<Props> = ({ themes, sortOrder }) => {
  return (
    <div className={styles.gridOverrides} data-testid="theme-grid">
      <Grid gutter={20} maxColumnCount={3} maxCardWidth={800} minCardWidth={0}>
        {(themes || [])
          .filter(familyTheme => familyTheme && familyTheme.themes?.length)
          .map((familyTheme, index) => (
            <ThemeCard familyTheme={familyTheme} key={`familyThemes${index}`} index={index} sortOrder={sortOrder} />
          ))}
      </Grid>
    </div>
  );
};
